import { ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useSubMenu } from '../SubMenuContext';

interface SeparadorProps {
	children: ReactNode;
	isSidebarOpen?: boolean;
}

const Separator = ({ children }: SeparadorProps) => {

	const { isSidebarOpen } = useSubMenu();

	return (
		<motion.div className={`h-5 flex items-center select-none mt-2 mb-2`} 
			initial={{ marginTop: isSidebarOpen ? 8 : 0, marginBottom: isSidebarOpen ? 8 : 0, paddingLeft: isSidebarOpen ? 12 : 0, }}
			animate={{ marginBottom: isSidebarOpen ? 8 : 0, marginTop: isSidebarOpen ? 8 : 0, paddingLeft: isSidebarOpen ? 12 : 0, }}
			transition={{ duration: 0.2, ease: 'easeInOut' }}>
			<div className={`font-semibold text-gray-400 text-xs break-normal whitespace-nowrap flex items-center h-full`}>
				<AnimatePresence >
					{isSidebarOpen ? (
						<motion.span className='h-full relative top-px flex items-center justify-center' key={'texto'} initial={isSidebarOpen ? false : { opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.1 }} exit={{ opacity: 0 }}>
							{children}
						</motion.span>
					) : (
						<div className='w-9 h-px bg-gray-100' key={'linha'} />
					)}
				</AnimatePresence>
			</div>
		</motion.div>
	);
};

export default Separator;
